import MCard from './MCard.vue';

MCard.install = (app) => {
  app.component('MCard', MCard);
};

export { MCard };
